/* =============================================================================
 * AADHAV ACADEMY – STATE MANAGEMENT SELECTORS
 * Module: Homework Submission Roster & Evaluation Pipeline
 * Scope: Standardized Multi-tenant Selectors
 * =============================================================================
 */

/**
 * Root Selector for Homework Submission Module
 */
export const selectHomeworkSubmissionState = (state) =>
  state.admin?.homeworkSubmission || state.homeworkSubmission || {};

/**
 * Selects the array log of global cross-tenant submissions
 */
export const selectHomeworkSubmissions = (state) =>
  selectHomeworkSubmissionState(state).homeworkSubmissions || [];

/**
 * Selects the operational API transmission loading states
 */
export const selectHomeworkSubmissionLoading = (state) =>
  selectHomeworkSubmissionState(state).loading || false;

/**
 * Selects system exception strings or connection error states
 */
export const selectHomeworkSubmissionError = (state) =>
  selectHomeworkSubmissionState(state).error || null;

/**
 * Selects current paginated collection offset metrics
 */
export const selectHomeworkSubmissionCurrentPage = (state) =>
  selectHomeworkSubmissionState(state).currentPage || 1;

/**
 * Selects calculated layout limits for max page dimensions
 */
export const selectHomeworkSubmissionTotalPages = (state) =>
  selectHomeworkSubmissionState(state).totalPages || 1;

/**
 * Selects absolute row counts for active evaluation profiles
 */
export const selectHomeworkSubmissionTotal = (state) =>
  selectHomeworkSubmissionState(state).total || 0;

/**
 * Selects the focused submission record node instance for granular evaluations
 */
export const selectSelectedHomeworkSubmission = (state) =>
  selectHomeworkSubmissionState(state).selectedHomeworkSubmission || null;